import React from 'react';
import './SelectedSeatsList.scss';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';

const SelectedSeatsList: React.SFC<{}> = ({
  children,
}) => (
  <WrapperBox style='selected-seats-list'>
    <FormattedText 
      style='title black'
      displayName='Biljetter'
      formattedName='order.tickets.header'
    />
    { React.Children.count(children) > 0 ? children :
      <FormattedText 
        displayName='Klicka på en ledig plats för att reservera.'
        formattedName='order.seatpicker.noreservations'
      />
    }
  </WrapperBox>
);

export default SelectedSeatsList;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/SelectedSeatsList/SelectedSeatsList.tsx